import { useDisclosure } from '@chakra-ui/react';
import React from 'react';

import { UploadModal } from './UploadModal';
import { IconButton } from 'packages/common-frontend/components/IconButton';
import { UploadFileExtension } from 'packages/manualDataTapeUploads/ui/UploadDataTapeDropzone';

type FileUploadButtonProps = {
  icon: React.ReactElement<any, string | React.JSXElementConstructor<any>>;
  allowedExtensions: UploadFileExtension[];
  modalHeaderText: string;
  handleFile: (file: File) => Promise<void>;
};
export const FileUploadButton = ({
  icon,
  modalHeaderText,
  handleFile,
  allowedExtensions,
}: FileUploadButtonProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <IconButton
        ariaLabel={modalHeaderText}
        icon={icon}
        label={modalHeaderText}
        onClick={onOpen}
      />
      <UploadModal
        modalHeaderText={modalHeaderText}
        isOpen={isOpen}
        onClose={onClose}
        handleFile={handleFile}
        allowedExtensions={allowedExtensions}
      />
    </>
  );
};
